<template>
    <v-ons-bottom-toolbar class="white">
        <div class="rigth">
            <img height="10px" v-if="false" :src="img"/>
        </div>
    </v-ons-bottom-toolbar>
</template>

<script>
    const log = function (args) {
        console.log(args);
    }
    export default {
        name: 'BottomBar',
        data: function () {
            return {
                img: require('./../assets/img/UI/Recurso 23.png')
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .white {
        background: white;
    }

    .rigth {
        text-align: right;
        padding-right: 5%;
    }

</style>



// WEBPACK FOOTER //
// src/components/BottomBar.vue